import { render, staticRenderFns } from "./TopBrowsedItems.vue?vue&type=template&id=38dc72e3&scoped=true"
import script from "./TopBrowsedItems.vue?vue&type=script&lang=js"
export * from "./TopBrowsedItems.vue?vue&type=script&lang=js"
import style0 from "./TopBrowsedItems.vue?vue&type=style&index=0&id=38dc72e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc72e3",
  null
  
)

export default component.exports